import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider.js'
import FinanceTagsDt from '@/services/dataTransferModules/financeTagsDt'

export default function useFinanceTags(params = {}) {
	const financeTagsDt = new FinanceTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingFinanceTag: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: financeTags,
		getEntities: getFinanceTags,

		entity: financeTag,
		getEntity: getFinanceTag,

		entityPreview: financeTagPreview,
		getEntityPreview: getFinanceTagPreview,

		entityPopup: financeTagPopup,
		getEntityPopup: getFinanceTagPopup,

		createEntity: createFinanceTag,

		patchEntity: putFinanceTag,
		updateEntity: updateFinanceTag,

		deleteEntity: deleteFinanceTag
	} = useBlProviders(
		financeTagsDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Finance tags loaded with an error'),

			showErrorNotificationForCreatingEntity: true,
			errorNotificationTextForCreatingEntity: $t('Error when adding finance tag'),

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error when editing a finance tag'),

			showErrorNotificationForDeletingEntity: true,
		}, params))

	return {
		flags,
		financeTags,
		financeTagPreview,
		financeTagPopup,
		financeTag,
		defaults,
		getFinanceTags,
		getFinanceTagPreview,
		getFinanceTagPopup,
		getFinanceTag,
		createFinanceTag,
		deleteFinanceTag,
		updateFinanceTag,
		putFinanceTag,
	}
}
